<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_1"><img alt="Image" height="268" src="images/2.jpg" width="350"/></a></p><a id="page_1">
<p class="noindent">Being on your own is all about making decisions. Big decisions: What do I want to do with my life? And lots of little decisions: What kind of laundry detergent should I buy? What should I have for breakfast? To start, let’s go up to 30,000 feet and look at the big decisions. Then we’ll come back down and tackle the everyday nitty-gritty.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?77d7174f